import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Layout } from '../Layout';

const AdminRoutes = ({ component: Component, ...rest }) => {
  const { auth, path, location } = rest;
  const { isAuthenticated, userInfo } = auth;

  return isAuthenticated && userInfo?.isFrontAdmin ? (
    <Layout exact path={path} component={Component} isAuthenticated={isAuthenticated} />
  ) : (
    <Redirect
      to={{
        pathname: isAuthenticated ? '/' : '/login',
        state: { from: location },
      }}
    />
  );
};

AdminRoutes.propTypes = {
  component: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  auth: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    redirectTo: PropTypes.string,
  }),
  redirectTo: PropTypes.string.isRequired,
};

AdminRoutes.defaultProps = {
  auth: {
    loading: () => {},
    isAuthenticated: () => {},
    redirectTo: () => {},
  },
};

const mapStateToProps = state => ({
  auth: state.toJS().auth,
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AdminRoutes);
